import ajax from '../../img/ajax.svg'

const Ajax = () => {

	return (
		<div className="mt-2 mb-2">
			<img className="ajax" src={ajax} />
		</div>
	);

}

export default Ajax;